import { useState } from 'react';
import { Button, Row, Col, FormGroup, Input, Label } from 'reactstrap';

//Components
import TextField from '../../../../../components/TextField';
import ModalCustomized from '../../../../../components/Modal/Modal';

//Helpers
import { showMessage } from '../../../../../helpers/message';
import {
    fatorMask,
    montarPrevia,
    sugerirVigencia,
    validarDadosReajuste,
    TAMANHO_MAXIMO_ATO,
    TAMANHO_MAXIMO_OBSERVACAO
} from '../../../../../helpers/reajusteInfracao';

function initialStateReajuste() {
    return {
        atoAdministrativo: "",
        ...sugerirVigencia(),
        fatorCorrecao: "0,0000",
        aplicarReincidencia: false,
        observacao: ""
    };
}

export default function ModalRecalculoInfracoes({ infracoes, openRecalculoModal, setOpenRecalculoModal, setReajusteEmPreparo }) {
    const [dados, setDados] = useState(initialStateReajuste());

    const toggleRecalculoModal = () => setOpenRecalculoModal(!openRecalculoModal);

    const onChange = (e) => {
        const { name, value } = e.target;
        setDados(anterior => ({ ...anterior, [name]: value }));
    };

    const handleGerarPrevia = () => {
        const mensagem = validarDadosReajuste(dados);
        if (mensagem)
            return showMessage("Aviso", mensagem, "warning", null);

        const previa = montarPrevia(infracoes, dados.fatorCorrecao, dados.aplicarReincidencia);
        if (previa.length === 0)
            return showMessage("Aviso", "Não há infrações ativas com valor para reajustar.", "warning", null);

        setReajusteEmPreparo({ dados, previa });
        toggleRecalculoModal();
    };

    return (
        <ModalCustomized
            size={'md'}
            fullscreen={"lg"}
            toggle={toggleRecalculoModal}
            widthPadrao={false}
            isOpen={openRecalculoModal}
            btnClose={toggleRecalculoModal}
            title={"Agendar Reajuste das Infrações"}
        >
            <Row>
                <Col md={12} lg={12}>
                    <TextField
                        label="* Ato administrativo"
                        name="atoAdministrativo"
                        type="text"
                        value={dados.atoAdministrativo}
                        onChange={onChange}
                        maxLength={TAMANHO_MAXIMO_ATO}
                    />
                </Col>
                <Col md={6} lg={6}>
                    <TextField
                        label="* Início da vigência"
                        name="inicioVigencia"
                        type="date"
                        value={dados.inicioVigencia}
                        onChange={onChange}
                    />
                </Col>
                <Col md={6} lg={6}>
                    <TextField
                        label="* Fim da vigência"
                        name="fimVigencia"
                        type="date"
                        value={dados.fimVigencia}
                        onChange={onChange}
                    />
                </Col>
                <Col md={12} lg={12}>
                    <TextField
                        label="* Fator de correção (ex.: 0,0452 para 4,52%). Os valores das infrações são multiplicadores da UFM, não R$"
                        name="fatorCorrecao"
                        type="text"
                        value={dados.fatorCorrecao}
                        onChange={onChange}
                        mask={fatorMask}
                    />
                </Col>
                <Col md={12} lg={12}>
                    <TextField
                        label="* Observação (normativa que estabeleceu o índice)"
                        name="observacao"
                        type="text"
                        value={dados.observacao}
                        onChange={onChange}
                        maxLength={TAMANHO_MAXIMO_OBSERVACAO}
                    />
                </Col>
                <Col md={12} lg={12}>
                    <FormGroup check className="mb-2">
                        <Input
                            id="aplicarReincidencia"
                            type="checkbox"
                            checked={dados.aplicarReincidencia}
                            onChange={(e) => setDados(anterior => ({ ...anterior, aplicarReincidencia: e.target.checked }))}
                        />
                        <Label check for="aplicarReincidencia">
                            Aplicar o índice também ao valor de reincidência
                        </Label>
                    </FormGroup>
                </Col>
            </Row>

            <Row className='d-flex justify-content-center align-items-center mt-3'>
                <Col md={6} lg={4}>
                    <Button
                        color='secondary'
                        className='text-white fw-bold w-100'
                        onClick={toggleRecalculoModal}
                    >
                        Cancelar
                    </Button>
                </Col>
                <Col md={6} lg={4}>
                    <Button
                        color='success'
                        className='text-white fw-bold w-100'
                        onClick={handleGerarPrevia}
                    >
                        Calcular prévia
                    </Button>
                </Col>
            </Row>
        </ModalCustomized>
    );
}
